(function () {
  'use strict'

  const MODULE_NAME = 'thismoment.embed.component.playlist'
  const templateUrl = require('./tpl/embed-playlist.html')

  require('./scss/embed-playlist.scss')

  require('angular')
    .module(MODULE_NAME, [
      require('../../../analytics'),
      require('../../../content'),
      require('../../../expandedContent'),
      require('../../../playlist')
    ]).component('thismomentEmbedPlaylist', {
      templateUrl: templateUrl,
      bindings: {
        embedId: '=',
        embedName: '=',
        ready: '=',
        ariaLabel: '=',
        cardOptions: '=',
        displayCart: '=',
        maxColumnCount: '=',
        loaderColor: '=',
        layoutOptions: '=',
        playlistId: '=',
        playlistOrder: '=',
        playlistSearch: '='
      },
      controller: embedPlaylistController
    })

  embedPlaylistController.$inject = ['$location', '$scope', 'SdkConfig', 'analyticsSDK', 'PlaylistContent', 'Content', 'ExpandedContent']
  function embedPlaylistController ($location, $scope, SdkConfig, analyticsSDK, PlaylistContent, Content, ExpandedContent) {
    var vm = this

    vm.$onInit = embedPlaylistInit

    function embedPlaylistInit () {
      $scope.$watch('$ctrl.ready', (ready) => {
        if (!ready) {
          return
        }

        vm.loadItems = loadItems
        vm.paginatorLimit = SdkConfig.get('is_mobile') ? 8 : 16

        // Deeplink logic
        var params = $location.search()
        if ('playlistId' in params && params.playlistId === vm.playlistId.toString() && 'contentId' in params) {
          PlaylistContent
            .get(
              {
                playlist_id: params.playlistId,
                content_id: params.contentId
              },
              function (response) {
                if (angular.isArray(response.data.content) && response.data.content.length > 0) {
                  Content.addContent('deeplink', response.data.content[0])
                  ExpandedContent.open(response.data.content[0], { displayShare: true, playlistId: params.playlistId })
                }
              }
            )
        }

        vm.displaySearch = vm.playlistSearch
        function loadItems (limit, offset, search, order, randomcontent, success, error) {
          return PlaylistContent.get({
            playlist_id: vm.playlistId,
            limit: limit,
            offset: offset,
            search_query: search,
            order: order,
            random_content: randomcontent,
            meta: false
          }, (response) => {
            var items = response.data.content
            if (typeof success === 'function') success(items)
            return items
          }, error)
        }

        // analytics
        vm.trackEvent = analyticsSDK.setupEventTracking({
          'embed title': vm.embedName,
          'embed type': 'playlist',
          'tm embed id': vm.embedId
        })
        vm.trackEvent('Embed Viewed', {
          'event trigger': 'loaded embed'
        })
      })
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/embed/component/embed-playlist/index.js